import styled from '@emotion/styled';

export const ActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[4],
}));

export const BadgeAnchor = styled('span')({
  position: 'relative',
  display: 'inline-flex',
});

export const NotificationBadge = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: 5,
  right: 5,
  width: 8,
  height: 8,
  borderRadius: theme.radius.full,
  backgroundColor: theme.colors.error.solid,
  pointerEvents: 'none',
}));
